import { InitialIntegrationReducer } from "../../../../_services/store/InitialIntegrationReducer";
import { createSlice } from "@reduxjs/toolkit";
import { INITIAL_NEW_CONFIGURATION, integrationReducerActions } from "../../../../_commons/integration.reducer";

export const initialEbayPaymentsReducer = {
    ...new InitialIntegrationReducer(),
    newConfiguration: {
        ...INITIAL_NEW_CONFIGURATION,
    },
};

const ebayPaymentsSlice = createSlice({
    name: "eBay Payments",
    initialState: { ...initialEbayPaymentsReducer },
    reducers: {
        ...integrationReducerActions,
    },
});

export default ebayPaymentsSlice;
